module.exports = __webpack_public_path__ + "files/surv.ab7cc5c014ab3d4125d7d8ac75b5dba2.pdf";